export default "__VITE_ASSET__gcMKFwnT__"